export default "__VITE_ASSET__TnC7wbwU__"